'use client';

import { useEffect, useState } from 'react';

// ローカルJPEG（/public/img）から1枚をランダム選択
const DEFAULT_IMAGES = [
  '/img/00.jpg',
  '/img/01.jpg',
  '/img/02.jpg',
  '/img/03.jpg',
  '/img/04.jpg',
  '/img/05.jpg',
  '/img/06.jpg',
];

interface HeroBackgroundMosaicProps {
  images?: string[];
}

export default function HeroBackgroundMosaic({ images }: HeroBackgroundMosaicProps) {
  const imgList = images ?? DEFAULT_IMAGES;
  const [src, setSrc] = useState<string | null>(null);
  const [fallbackApplied, setFallbackApplied] = useState(false);

  useEffect(() => {
    // ランダムで1枚選択
    const idx = Math.floor(Math.random() * imgList.length);
    const candidate = imgList[idx];

    if (typeof window !== 'undefined') {
      const tester = new window.Image();
      tester.onload = () => {
        setSrc(candidate);
      };
      tester.onerror = () => {
        if (!fallbackApplied) {
          setSrc('/globe.svg');
          setFallbackApplied(true);
        }
      };
      tester.src = candidate;
    } else {
      setSrc(candidate);
    }
  }, []);

  if (!src) return null;

  return (
    <div
      className="absolute inset-0 z-0 bg-center bg-cover"
      style={{ backgroundImage: `url(${src})` }}
      aria-hidden
    />
  );
}
